import { ProductSlider } from './ProductSlider'
import { useProductAttributes } from '../../../state'

export function AutoRelated() {
  const { autoRelatedProducts, loadingAutoRelated } = useProductAttributes()

  return (
    <ProductSlider
      products={autoRelatedProducts}
      loading={loadingAutoRelated}
      title="Produse similare"
    />
  )
}
